<template>
  <div>
    <span v-if="typeof boardDocumentID === 'string' || typeof boardDocumentID === 'number'">
      <button
        :class="
          isprimary !== undefined && isprimary === true
            ? 'button is-primary is-small is-outline is-rounded'
            : 'button is-info is-light is-small is-outline is-rounded'
        "
        :title="tooltip"
        @click.prevent="downloadPdf(boardDocumentID)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    boardDocumentID: [Number, String],
    documentID: [Number, String],
    downloadPdf: Function
  }
}
</script>
